export default {
  period: 'Analysis period',
  mixMode: 'Mix mode',
  progress: '{done} of {total} budgets computed',
  kpi: 'KPI',
  delete: 'Delete',
  cancel: 'Cancel',
  deleteTitle: 'Delete budget simulation',
  deleteConfirm: 'Delete "{name}" and the plans of all its budgets? This cannot be undone.',
  waiting: 'The budgets are being computed. The charts appear as each one finishes.',
  totalSaturationCurve: 'Total Saturation Curve',
  roasByBudget: 'Total ROAS at different Budget Levels',
  mixByBudget: 'Media Mix at different Budget Levels',
  budgetLevel: 'Budget',
  ofReference: '{pct}% of reference',
  // XLSX download
  xlsxSimulation: 'Budget simulation',
  xlsxGridBudgets: 'Grid budgets ({unit})',
  xlsxPctOfReference: '% of reference',
  xlsxOptimalZones: 'Optimal Zones',
  xlsxZone: 'Zone',
  xlsxFrom: 'From',
  xlsxTo: 'To',
  xlsxFrozenMix: 'Frozen Mix',
  xlsxShare: 'Share (%)',
  xlsxPeriod: 'Period'
}
